const SvgComponent = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.83203 7.9165L9.9987 12.0832L14.1654 7.9165" stroke="#6AB97A" strokeWidth="1.8" />
  </svg>
);

export default SvgComponent;
